// extracted by mini-css-extract-plugin
export default {"discountRateWrapper":"InvestmentForm_discountRateWrapper__BbYef","currencyWrapper":"InvestmentForm_currencyWrapper__-oPDo"};